import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../components/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentUser: any = null;

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  get isProvider(): boolean { return this.currentUser?.role === 'provider'; }
  get isCustomer(): boolean { return this.currentUser?.role === 'customer'; }
  get isLoggedIn(): boolean { return !!this.currentUser; }

  goToDashboard(): void {
    this.router.navigate([this.isProvider ? '/provider-dashboard' : '/dashboard']);
  }

  browseServices(): void {
    this.router.navigate(['/browse-services']);
  }

  becomeProvider(): void {
    if (this.isLoggedIn) {
      this.router.navigate(['/become-provider']);
    } else {
      this.router.navigate(['/auth'], { queryParams: { type: 'provider' } });
    }
  }

  login(): void {
    this.router.navigate(['/auth']);
  }
}
